/* eslint-disable radix */
import { toast, ToastContainer } from "react-toastify";
import { httprequest } from "../../data/api";
import { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { Grid } from "@mui/material";
import InputGroup from "../../components/FormComponent/InputGroup";
import Button from "../../components/Button/Button";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Icon } from "@iconify/react";
import Select from "react-select";
import "./styles.css";
const Index = () => {
  const [subscriptionName, setSubscriptionName] = useState("");
  const [amount, setAmount] = useState("");
  const currencyOptions = [
    { value: "₦", label: "Nigerian Naira" },
    { value: "$", label: "US Dollar" },
    { value: "€", label: "Euro" },
    { value: "£", label: "British Pound" },
    { value: "¥", label: "Japanese Yen" },
    { value: "C$", label: "Canadian Dollar" }
  ];
  const [currency, setCurrency] = useState("");
  const [tokenUnits, setTokenUnits] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const fetchPackages = () => {
    httprequest
      .get("/admin/v1/email-package")
      .then((res) => {
        setPackages(res.data.data);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error fetching packages");
      });
  };

  const resetFormFields = () => {
    setSubscriptionName("");
    setAmount("");
    setCurrency("");
    setTokenUnits("");
  };

  const handleCreateSubscription = () => {
    setIsLoading(true);

    const newSubscription = {
      name: subscriptionName,
      amount: parseFloat(amount),
      currency,
      unit: parseInt(tokenUnits, 10)
    };

    httprequest
      .post("/admin/v1/email-package", newSubscription)
      .then((res) => {
        toast.success(res.data.message);
        setIsSubscriptionModalOpen(false);
        resetFormFields();
        fetchPackages();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error creating subscription");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleEditSubscription = () => {
    setIsLoading(true);

    const updatedSubscription = {
      name: subscriptionName,
      amount: parseFloat(amount),
      currency,
      unit: parseInt(tokenUnits, 10)
    };

    httprequest
      .patch(`/admin/v1/email-package/${selectedPackage.id}`, updatedSubscription)
      .then((res) => {
        toast.success(res.data.message);
        setIsEditModalOpen(false);
        resetFormFields();
        fetchPackages();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error updating subscription");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const openDeleteModal = (item) => {
    setSelectedPackage(item);
    setIsDeleteModalOpen(true);
  };
  const handleDeletePackage = () => {
    setIsLoading(true);

    httprequest
      .delete(`/admin/v1/email-package/${selectedPackage.id}`)
      .then((res) => {
        toast.success(res.data.message);
        setIsDeleteModalOpen(false);
        fetchPackages();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error deleting package");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const openEditModal = (item) => {
    setSelectedPackage(item);
    setSubscriptionName(item.name);
    setCurrency(item.currency);
    setAmount(item.amount);
    setTokenUnits(item.unit);
    setIsEditModalOpen(true);
  };

  const handleCloseSubscriptionModal = () => {
    setIsSubscriptionModalOpen(false);
    resetFormFields();
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Email Subscription"
            subtitle="Set the subscription models for emails."
            button={
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                onClick={() => setIsSubscriptionModalOpen(true)}
                buttonName={<div className="flex align-items-center gap-5"><span><Icon icon="material-symbols:add-circle-outline" /></span>Create Subscription Model</div>}
              />
            }
          />
          <div className="subcription-content">
            {packages.map((item) => (
              <div className="sub_card" key={item.id}>
                <div className="head">
                  <span>
                    {item.name}
                  </span>
                  <div onClick={() => openDeleteModal(item)}
                    style={{ cursor: "pointer" }} className="sub_card_buttons"
                  >
                    <Icon icon="material-symbols:delete-outline-sharp" />
                  </div>
                </div>
                <div className="price">
                  <h2>{item.currency}{item.amount}</h2>/<span>{item.unit}units</span>
                </div>
                <button onClick={() => openEditModal(item)}>Edit</button>
              </div>
            ))}
          </div>
          <Modal
            title="Create Email Subscription Model"
            subtitle="Here you can create email subscription models for schools to use."
            modalContent={
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Subscription Name"
                    margin="normal"
                    required
                    inputName="name"
                    placeholder="Enter name"
                    inputType="text"
                    onChange={(e) => setSubscriptionName(e.target.value)}
                    value={subscriptionName}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup
                    label="Amount"
                    margin="normal"
                    required
                    inputName="amount"
                    placeholder="Enter amount"
                    inputType="number"
                    onChange={(e) => setAmount(e.target.value)}
                    value={amount}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <div className="multiple-select">
                    <p>
                 Select Currency
                      <span className="input-required"> * </span>
                    </p>
                    <Select
                      options={currencyOptions}
                      value={currencyOptions.find(option => option.value === currency)}
                      onChange={(selectedOption) => setCurrency(selectedOption.value)}
                      placeholder="Select Currency"
                      isSearchable={false}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Token Units"
                    margin="normal"
                    required
                    inputName="unit"
                    placeholder="Enter token units"
                    inputType="number"
                    onChange={(e) => setTokenUnits(e.target.value)}
                    value={tokenUnits}
                  />
                </Grid>
              </Grid>
            }
            modalFooter={
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Create"
                isLoading={isLoading}
                onClick={handleCreateSubscription}
              />
            }
            isopen={isSubscriptionModalOpen}
            closeModal={handleCloseSubscriptionModal}
          />

          <Modal
            title="Edit Email Subscription Model"
            subtitle="Here you can edit email subscription models for schools to use."
            modalContent={
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Subscription Name"
                    margin="normal"
                    required
                    inputName="name"
                    placeholder="Enter name"
                    inputType="text"
                    onChange={(e) => setSubscriptionName(e.target.value)}
                    value={subscriptionName}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup
                    label="Amount"
                    margin="normal"
                    required
                    inputName="amount"
                    placeholder="Enter amount"
                    inputType="number"
                    onChange={(e) => setAmount(e.target.value)}
                    value={amount}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <div className="multiple-select">
                    <p>
                 Select Currency
                      <span className="input-required"> * </span>
                    </p>
                    <Select
                      options={currencyOptions}
                      value={currencyOptions.find(option => option.value === currency)}
                      onChange={(selectedOption) => setCurrency(selectedOption.value)}
                      placeholder="Select Currency"
                      isSearchable={false}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Token Units"
                    margin="normal"
                    required
                    inputName="unit"
                    placeholder="Enter token units"
                    inputType="number"
                    onChange={(e) => setTokenUnits(e.target.value)}
                    value={tokenUnits}
                  />
                </Grid>
              </Grid>
            }
            modalFooter={
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Update"
                isLoading={isLoading}
                onClick={handleEditSubscription}
              />
            }
            isopen={isEditModalOpen}
            closeModal={() => setIsEditModalOpen(false)}
          />

          <Modal
            title="Delete Package"
            subtitle="Are you sure you want to delete this package?"
            modalFooter={
              <>
                <Button
                  variant="danger"
                  buttonSize="full"
                  color="btndefault"
                  isLoading={isLoading}
                  buttonName="Delete Package"
                  onClick={handleDeletePackage}
                />
              </>
            }
            isopen={isDeleteModalOpen}
            closeModal={() => setIsDeleteModalOpen(false)}
          />
          <ToastContainer />
        </>
      }
    />
  );
};

export default Index;
